import { createActions } from 'redux-actions';
import { PolicyCommissionInvoice } from '@models/PolicyCommissionInvoice';
import { GetPolicyCommissionInvoiceParams } from '@apis/PolicyCommissionInvoiceApi';

export type State = {
  invoice?: PolicyCommissionInvoice | null;
};

export type PolicyCommissionInvoiceFetchPayload = GetPolicyCommissionInvoiceParams;
export type StateUpdatePayload = Partial<State>;

export const {
  policyCommissionInvoiceFetch,
  stateUpdate,
  stateClear,
} = createActions(
  'POLICY_COMMISSION_INVOICE_FETCH',
  'STATE_UPDATE',
  'STATE_CLEAR',
  {
    prefix: 'POLICY_COMMISSION_INVOICE_DETAIlS_PAGE',
  },
);
